import {
  APPOINTMENT_POST,
  APPOINTMENT_POST_CLEAR_DATA,
  APPOINTMENT_POST_ERROR,
  APPOINTMENT_POST_SUCCESS,
  APPOINTMENTACTION_PATCH,
  APPOINTMENTACTION_PATCH_CLEAR_DATA,
  APPOINTMENTACTION_PATCH_ERROR,
  APPOINTMENTACTION_PATCH_SUCCESS,
  APPOINTMENTAVAILABILITY_POST,
  APPOINTMENTAVAILABILITY_POST_CLEAR_DATA,
  APPOINTMENTAVAILABILITY_POST_ERROR,
  APPOINTMENTAVAILABILITY_POST_SUCCESS,
  EXECUTIVELIST_GET,
  EXECUTIVELIST_GET_CLEAR_DATA,
  EXECUTIVELIST_GET_ERROR,
  EXECUTIVELIST_GET_SUCCESS,
  GET_APPOINTMENT,
  GET_APPOINTMENT_ACTION,
  GET_APPOINTMENT_ACTION_CLEAR_DATA,
  GET_APPOINTMENT_ACTION_ERROR,
  GET_APPOINTMENT_ACTION_SUCCESS,
  GET_APPOINTMENT_CLEAR_DATA,
  GET_APPOINTMENT_ERROR,
  GET_APPOINTMENT_SUCCESS,
} from "./actionTypes";

export const getAppointment = (appointment, history) => {
  return {
    type: GET_APPOINTMENT,
    payload: { appointment, history },
  };
};

export const getAppointmentSuccess = (success) => {
  return {
    type: GET_APPOINTMENT_SUCCESS,
    payload: success,
  };
};

export const getAppointmentError = (error) => {
  return {
    type: GET_APPOINTMENT_ERROR,
    payload: error,
  };
};

export const getAppointmentClearData = () => {
  return {
    type: GET_APPOINTMENT_CLEAR_DATA,
    payload: {},
  };
};

export const getAppointmentAction = (appointment, history) => {
  return {
    type: GET_APPOINTMENT_ACTION,
    payload: { appointment, history },
  };
};

export const getAppointmentActionSuccess = (success) => {
  return {
    type: GET_APPOINTMENT_ACTION_SUCCESS,
    payload: success,
  };
};

export const getAppointmentActionError = (error) => {
  return {
    type: GET_APPOINTMENT_ACTION_ERROR,
    payload: error,
  };
};

export const getAppointmentActionClearData = () => {
  return {
    type: GET_APPOINTMENT_ACTION_CLEAR_DATA,
    payload: {},
  };
};

export const appointmentActionPatch = (
  appointmentActionBody,
  appointmentId,
) => {
  return {
    type: APPOINTMENTACTION_PATCH,
    payload: { appointmentActionBody, appointmentId },
  };
};

export const appointmentActionPatchSuccess = (success) => {
  return {
    type: APPOINTMENTACTION_PATCH_SUCCESS,
    payload: success,
  };
};

export const appointmentActionPatchError = (error) => {
  return {
    type: APPOINTMENTACTION_PATCH_ERROR,
    payload: error,
  };
};

export const appointmentActionPatchClearData = () => {
  return {
    type: APPOINTMENTACTION_PATCH_CLEAR_DATA,
    payload: {},
  };
};

export const executiveListGet = (executiveListBody) => {
  return {
    type: EXECUTIVELIST_GET,
    payload: { executiveListBody },
  };
};

export const executiveListGetSuccess = (success) => {
  return {
    type: EXECUTIVELIST_GET_SUCCESS,
    payload: success,
  };
};

export const executiveListGetError = (error) => {
  return {
    type: EXECUTIVELIST_GET_ERROR,
    payload: error,
  };
};

export const executiveListGetClearData = () => {
  return {
    type: EXECUTIVELIST_GET_CLEAR_DATA,
    payload: {},
  };
};

export const appointmentAvailabilityPost = (appointmentAvailabilityBody) => {
  return {
    type: APPOINTMENTAVAILABILITY_POST,
    payload: { appointmentAvailabilityBody },
  };
};

export const appointmentAvailabilityPostSuccess = (success) => {
  return {
    type: APPOINTMENTAVAILABILITY_POST_SUCCESS,
    payload: success,
  };
};

export const appointmentAvailabilityPostError = (error) => {
  return {
    type: APPOINTMENTAVAILABILITY_POST_ERROR,
    payload: error,
  };
};

export const appointmentAvailabilityPostClearData = () => {
  return {
    type: APPOINTMENTAVAILABILITY_POST_CLEAR_DATA,
    payload: {},
  };
};

export const appointmentPost = (appointmentBody) => {
  return {
    type: APPOINTMENT_POST,
    payload: { appointmentBody },
  };
};

export const appointmentPostSuccess = (success) => {
  return {
    type: APPOINTMENT_POST_SUCCESS,
    payload: success,
  };
};

export const appointmentPostError = (error) => {
  return {
    type: APPOINTMENT_POST_ERROR,
    payload: error,
  };
};

export const appointmentPostClearData = () => {
  return {
    type: APPOINTMENT_POST_CLEAR_DATA,
    payload: {},
  };
};
